import FormControl from '@mui/material/FormControl';
import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { SelectOptionType } from '../utils/Types';

interface IMAutoCompleteProps {
  label: string;
  value?: SelectOptionType;
  icon?: React.ReactElement;
  onChange?: (value: any) => void;
  onIconClick?: () => void;
  disabled?: boolean;
  options: SelectOptionType[];
  dataTestId?: string;
  minCharsToFilter?: boolean;
  required?: boolean;
}

const filter = createFilterOptions({
  matchFrom: 'start',
  stringify: (option: any) => option.label,
});
const MAutoComplete: React.FunctionComponent<IMAutoCompleteProps> = ({
  label,
  value,
  onChange,
  disabled,
  options,
  minCharsToFilter = false,
  required = false,
}) => {
  return (
    <FormControl fullWidth>
      <Autocomplete
        disablePortal
        id={`autocomplete-box-${label}`}
        options={options}
        disabled={disabled}
        value={value}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderOption={(props, option) => (
          <li {...props} key={`${option.value}-${option.label}`}>
            {option.label}
          </li>
        )}
        ListboxProps={{
          sx: { fontSize: '14px' },
        }}
        onChange={(_event: any, newValue: any) => {
          if (onChange) onChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="standard"
            className="text-field"
            required={required}
            InputLabelProps={{
              sx: {
                '& .MuiFormLabel-asterisk': {
                  color: 'red',
                },
              },
            }}
          />
        )}
        filterOptions={(options, params) => {
          if (minCharsToFilter && params.inputValue.length < 3) {
            return options;
          }
          return filter(options, params);
        }}
      />
    </FormControl>
  );
};

export default MAutoComplete;
